<app-dialog
  [key]="'edit-demand'"
  [action]="'edit-demand'"
  [headerTheme]="'simple'"
  (sendDialogAction)="handleDialogAction($event)"
  (onClose)="close()"
  [title]="'Editar demanda'">
  <div class="ndf-calculator-list__dialog px-2">
    <form *ngIf="demandForm" [formGroup]="demandForm" appAutoFormGroup>
      <div class="container-fluid px-0">
        <div class="row px-0">
          <div class="col-5 mb-3">
            <app-select-company
              class="w-100"
              [formGroup]="demandForm"
              [controlName]="demandRegisterProps.companyId"
              [label]="tk.Management.Company | t"
              [disabled]="!!demandId"
              (sendSelectedOption)="handleOptionChange($event, 'companyId')"
              [placeholder]="tk.User.Select | t">
            </app-select-company>
          </div>
          <div class="col-7">
            <app-select
              class="w-100"
              [label]="(tk.Control.OperationType3 | t) + ' *'"
              [options]="operationOptions"
              [formGroup]="demandForm"
              [controlName]="demandRegisterProps.operationType"
              (sendSelectedOption)="handleOptionChange($event, 'operationType')"
              [placeholder]="tk.User.Select | t">
            </app-select>
          </div>
        </div>

        <!-- COMEX Operations Select -->
        <div class="row px-0" *ngIf="showComexOperations">
          <div class="col-12 mb-3">
            <app-select
              class="w-100"
              [label]="(tk.Management.NdfOperation | t) + ' *'"
              [options]="comexOperations"
              [formGroup]="demandForm"
              [controlName]="'comexOperationId'"
              (sendSelectedOption)="handleOptionChange($event, 'comexOperation')"
              [placeholder]="tk.User.Select | t">
            </app-select>
          </div>
        </div>

        <!-- Loan Operations Select -->
        <div class="row px-0" *ngIf="showLoanOperations">
          <div class="col-12 mb-3">
            <app-select
              class="w-100"
              [label]="(tk.Management.NdfOperation | t) + ' *'"
              [options]="loanOperations"
              [formGroup]="demandForm"
              [controlName]="'loanOperationId'"
              (sendSelectedOption)="handleOptionChange($event, 'loanOperation')"
              [placeholder]="tk.User.Select | t">
            </app-select>
          </div>
        </div>

        <!-- Indicative Fields -->
        <ng-container *ngIf="showIndicativeFields">
          <div class="row px-0" *ngIf="showIndicativeFields">
            <div class="col-7">
              <app-input
                [formGroup]="demandForm"
                [type]="'text'"
                [controlName]="demandRegisterProps.reference"
                [label]="tk.Management.NdfReference | t"
                [required]="false">
              </app-input>
            </div>
            <div class="col-5 mb-3">
              <app-select
                class="w-100"
                [label]="(tk.Management.NdfCurrency | t) + ' *'"
                [options]="currencyOptions"
                [formGroup]="demandForm"
                [controlName]="demandRegisterProps.internationalCurrencyId"
                (sendSelectedOption)="handleOptionChange($event, 'internationalCurrencyId')"
                [placeholder]="tk.User.Select | t">
              </app-select>
            </div>
          </div>
          <div class="row px-0">
            <div class="col-3 mb-3">
              <app-input
                [type]="'number'"
                [label]="(tk.Management.NdfValue | t) || ''"
                [controlName]="demandRegisterProps.transactionValue"
                [formGroup]="demandForm"
                [minFractionDigits]="2"
                [maxFractionDigits]="2"
                [min]="0"
                [required]="false"
                (sendInputValue)="handleInputNumber($event, 'transactionValue')" />
            </div>
            <div class="col-3 mb-3">
              <app-input
                [type]="'number'"
                [label]="(tk.Management.BudgetRate1 | t) || ''"
                [controlName]="demandRegisterProps.budgetRate"
                [formGroup]="demandForm"
                [minFractionDigits]="4"
                [min]="0"
                [required]="false"
                (sendInputValue)="handleInputNumber($event, 'budgetRate')" />
            </div>
            <div class="col-6 mb-3">
              <app-calendar
                [formGroup]="demandForm"
                [controlName]="demandRegisterProps.dueAt"
                [label]="(tk.Management.NdfDueDate | t) || ''"
                [minDate]="minDueDate"
                [date]="demandForm.get(demandRegisterProps.dueAt)?.value || ''"
                [inputId]="'demand-dueat'"
                (sendCalendarValue)="handleCalendarValue($event, 'dueAt')" />
            </div>
          </div>
        </ng-container>
      </div>
    </form>
  </div>
  <app-button
    [id]="'save-demand'"
    [label]="tk.General.Save | t"
    [type]="'button'"
    (click)="saveEditedDemand()">
  </app-button>
</app-dialog>
